var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "#F5F5F5",
    stroke: "#DDDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0832 21.565L38.9502 19.7C39.0362 19.6141 39.0844 19.4975 39.0844 19.376C39.0844 19.2545 39.0362 19.1379 38.9502 19.052C38.8643 18.9661 38.7478 18.9178 38.6262 18.9178C38.5047 18.9178 38.3882 18.9661 38.3022 19.052L36.4362 20.917C34.352 18.9928 31.604 17.9498 28.7679 18.0064C25.9318 18.0629 23.2276 19.2147 21.2217 21.2205C19.2158 23.2262 18.0638 25.9304 18.0071 28.7665C17.9503 31.6026 18.9932 34.3506 20.9172 36.435L19.0512 38.3C18.9655 38.386 18.9174 38.5026 18.9174 38.624C18.9174 38.7455 18.9655 38.862 19.0512 38.948C19.0936 38.9909 19.144 39.0249 19.1997 39.0481C19.2553 39.0713 19.315 39.0831 19.3752 39.083C19.4969 39.0834 19.6137 39.0356 19.7002 38.95L21.5652 37.085C23.6493 39.0117 26.3983 40.0568 29.236 40.0011C32.0736 39.9453 34.7795 38.7932 36.7863 36.7861C38.7931 34.7791 39.9449 32.073 40.0003 29.2354C40.0556 26.3977 39.0102 23.6488 37.0832 21.565ZM18.9172 29C18.914 27.0447 19.4803 25.1308 20.5469 23.492C21.6136 21.8533 23.1344 20.5607 24.9237 19.7721C26.7129 18.9835 28.6931 18.7332 30.6223 19.0516C32.5515 19.37 34.3463 20.2433 35.7872 21.565L21.5652 35.787C19.8633 33.9364 18.9182 31.5142 18.9172 29ZM29.0002 39.083C26.486 39.082 24.0638 38.137 22.2132 36.435L36.4352 22.213C37.7569 23.654 38.6303 25.4487 38.9487 27.3779C39.2671 29.3071 39.0167 31.2873 38.2281 33.0766C37.4396 34.8658 36.147 36.3867 34.5082 37.4533C32.8695 38.52 30.9555 39.0863 29.0002 39.083Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup24);
export default __webpack_public_path__ + "static/media/Group 24.ad1e187560ea2eaecef35af1c72ec185.svg";
export { ForwardRef as ReactComponent };